import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, ValidateNested } from "class-validator";
import { PushMessage } from "../../entity";

export class GetAllPushMessageDTO {
  @Expose()
  @ValidateNested()
  @Type(() => PushMessage)
  @IsArray()
  pushMessages!: PushMessage[];

  @Expose()
  @IsNumber()
  pageCount!: number;
}
